import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { sound } from "@pixi/sound";
import { BitmapText, Color, Container, FillGradient, Text, TextStyle } from "pixi.js";
import { Group, Tween } from "tweedle.js";
import { currentBackgorundMusic, currentBackgorundMusicVolume, isMusicBtnOnGlobal, languageGlobal, setBackgorundMusic } from "../config/GlobalVariableConfig";
import { getFontConfig } from "../config/introTextConfig";

declare const window: any;
const translationManager = window.hacksawCasino.Translation;

// import { setBackgorundMusic, currentBackgorundMusicVolume } from "../config/GlobalVariableConfig";

export class Banner extends Container {

    public bgContainer = new Container();
    private texContainer = new Container(); //-- which needed to scale without any limit


    private bannerText1: Text = new Text({});
    private bannerText2: Text = new Text({});
    private bannerText3: Text = new Text({});
    private bannerText4: Text = new Text({});
    private bannerText5: Text = new Text({});
    private continueText: Text = new Text({});

    private backgroundSpine: Spine | null = null;

    private winText: BitmapText = new BitmapText({
        text: "",
        style: {
            fontFamily: "sugar_win_amount",
            trim: true,
            fontSize: 175,
            letterSpacing: 20,
        }
    });


    private tweenGroup: Group = new Group();

    private screenWidth: number;
    private screenHeight: number;


    constructor(screenWidth: number, screenHeight: number) {
        super();

        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        this.setupBackground();
        this.setupBannerText();

        this.visible = false;

        // this.bgContainer.eventMode = "static"
        this.resize(screenWidth, screenHeight);

    }


    private setupBackground(): void {


        this.backgroundSpine = Spine.from({
            skeleton: "bannerSkel",
            atlas: "bannerAtlas",
        });


        this.backgroundSpine.position.set(1920 / 2, 1080 / 2);

        // spineSymbol.scale=0.1;

        // this.backgroundSpine.state.setAnimation(0, "loop", true);

        this.bgContainer.addChild(this.backgroundSpine);
        this.addChild(this.bgContainer);


        this.addChild(this.texContainer);

    }


    private setupBannerText(): void {

        const {
            fontFamily: fontFamilyHeading,
            fontWeight: fontWeightHeading,
            fontSize: fontSizeHeading,
        } = getFontConfig(languageGlobal, "introHeading");



        const fill = new FillGradient(0, 0, 0, 25 * 1 * 5);
        const colors = [0xfff600, 0xffaa00].map((color) => Color.shared.setValue(color).toNumber());

        colors.forEach((number, index) => {
            const ratio = index / colors.length;

            fill.addColorStop(ratio, number);
        });

        this.bannerText1.style = new TextStyle({
            fontFamily: fontFamilyHeading,
            fill: "#ffffff",//{ fill },
            fontWeight: fontWeightHeading,
            fontSize: fontSizeHeading,
            stroke: {
                color: "#2f0056",
                width: 3,
            },
            dropShadow:
            {
                blur: 2,
                color: "#77002d",
                distance: 10,
            },
            letterSpacing: 1,
            align: "center",
            // breakWords: true,
            // wordWrap: true,
            // wordWrapWidth: 850,

        });



        const {
            fontFamily: fontFamilyDesc1,
            fontWeight: fontWeightDesc1,
            fontSize: fontSizeDesc1,
            lineHeight: lineHeightDesc1
        } = getFontConfig(languageGlobal, "introDesc1");

        this.bannerText2.style = new TextStyle({
            fontFamily: fontFamilyDesc1,
            fill: { fill },
            fontWeight: fontWeightDesc1,
            fontSize: fontSizeDesc1,
            // stroke: {
            //     color: "#000000",
            //     width: 3,
            // },
            dropShadow:
            {
                blur: 5,
                color: "#000000",
                distance: 6,
            },
            align: "center",
            // trim: true,
            letterSpacing: 1,
            // fontVariant: "small-caps",
            breakWords: true,
            wordWrap: true,
            wordWrapWidth: 950,
            lineHeight: lineHeightDesc1,
        });


        const {
            fontFamily: fontFamilyDesc2,
            fontWeight: fontWeightDesc2,
            fontSize: fontSizeDesc2,
            lineHeight: lineHeightDesc2
        } = getFontConfig(languageGlobal, "introDesc2");

        const desc2TextStyle = new TextStyle({
            fontFamily: fontFamilyDesc2,
            fill: "#ffffff",
            fontWeight: fontWeightDesc2,
            fontSize: fontSizeDesc2,
            // stroke: {
            //     color: "#000000",
            //     width: 2,
            // },
            dropShadow:
            {
                blur: 5,
                color: "#000000",
                distance: 2,
            },
            align: "center",
            wordWrap: true,
            // trim: true,
            letterSpacing: 1,
            wordWrapWidth: 950,
            lineHeight: lineHeightDesc2,
            breakWords: true,
        });

        this.bannerText3.style = desc2TextStyle;
        this.bannerText4.style = desc2TextStyle;
        this.bannerText5.style = desc2TextStyle;


        const {
            fontFamily: fontFamilyContinue,
            fontWeight: fontWeightContinue,
            fontSize: fontSizeContinue2,
        } = getFontConfig(languageGlobal, "introContinue");

        const continueTextStyle = new TextStyle({
            fontFamily: fontFamilyContinue,
            fill: "#ffffff",
            fontWeight: fontWeightContinue,
            fontSize: fontSizeContinue2,
            stroke: {
                color: "#000000",
                width: 2,
            },
            dropShadow:
            {
                blur: 5,
                color: "#000000",
                distance: 2,
            },
        });

        this.continueText.text = translationManager.game('intro_continue_uc')
        this.continueText.style = continueTextStyle


        this.bannerText1.anchor.set(0.5);
        this.bannerText2.anchor.set(0.5);
        this.bannerText3.anchor.set(0.5);
        this.bannerText4.anchor.set(0.5);
        this.bannerText5.anchor.set(0.5);
        this.continueText.anchor.set(0.5);
        this.winText.anchor.set(0.5);

        // const spacing = 20;
        this.texContainer.addChild(this.bannerText1);
        this.texContainer.addChild(this.bannerText2);
        this.texContainer.addChild(this.bannerText3);
        this.texContainer.addChild(this.bannerText4);
        this.texContainer.addChild(this.bannerText5);
        this.texContainer.addChild(this.continueText);
        this.texContainer.addChild(this.winText);
    }

    public async appearFreeGameIntroBanner(freeGameNumber: number) {

        return new Promise<void>((resolve) => {

            // this.visible = true;
            this.bannerText1.visible = true;
            this.bannerText2.visible = true;
            this.bannerText3.visible = true;
            this.bannerText4.visible = true;
            this.bannerText5.visible = true;

            this.winText.visible = false;

            this.bannerText1.scale.set(1);
            this.bannerText1.text = translationManager.game('banner_intro_heading_uc');// '8-BIT BONUS';
            this.bannerText1.scale = Math.min(1, 830 / this.bannerText1.width);
            this.bannerText1.y = -400;

            // this.bannerText2.scale = 1;

            this.bannerText2.text = translationManager.game('banner_intro_desc_1', null, { 'freegamenumber': freeGameNumber });//`You won ${freeGameNumber} Free Spins!`
            this.bannerText2.y = -225;
            // this.bannerText2.scale = Math.min(1, 850 / this.bannerText2.width);

            this.bannerText3.text = translationManager.game('banner_intro_desc_2');//'During the bonus game, the multiplier accumulates with each win that involves a wild symbol with a multiplier.';
            this.bannerText3.y = -70;
            // this.bannerText3.scale = Math.min(1, (this.bannerBackground.width - 150) / this.bannerText3.width);

            this.bannerText4.text = translationManager.game('banner_intro_desc_3');//'The multiplier persists throughout the entire duration of the bonus game.';
            this.bannerText4.y = 90;

            this.bannerText5.text = translationManager.game('banner_intro_desc_4');//'The multiplier persists throughout the entire duration of the bonus game.';
            this.bannerText5.y = 250;

            this.continueText.y = 400;


            this.texContainer.alpha = 0;
            this.texContainer.scale.set(0);

            this.visible = true;

            sound.play('Water_Fall', { volume: 0.5 });
            this.backgroundSpine.state.setAnimation(0, "in", false).listener = {
                complete: async () => {

                    sound.play('Free_Game_Banner_Appear', { volume: 0.3 });

                    this.backgroundSpine.state.setAnimation(0, "loop", true);

                    await this.appearText(true);
                    resolve();

                    this.backgroundSpine.state.clearListeners();
                }
            };

        })


    }

    private appearText(toFreeGame: boolean) {

        return new Promise<void>((resolve) => {

            let textScale;
            if (this.screenWidth > this.screenHeight) {
                textScale = Math.min(this.screenWidth / 1920, this.screenHeight / 1080);
            }
            else {
                textScale = Math.min(this.screenWidth / 1080, this.screenHeight / 1920);
            }

            this.texContainer.alpha = 0;
            this.texContainer.scale.set(0);
            const tweenAlpha = new Tween(this.texContainer, this.tweenGroup)
                // .to({ alpha: 1 }, 200)
                .to({ scale: { x: textScale, y: textScale }, alpha: 1 }, 500)
                // .easing(Easing.Bounce.Out)
                .onStart(() => {
                    if (toFreeGame) {
                        this.switchTheBackgroundMusic(toFreeGame);
                    }
                    else {

                    }
                })
                .onComplete(() => {
                    this.bgContainer.eventMode = "static";
                    // this.bgContainer.cursor = 'pointer';
                    this.tweenGroup.remove(tweenAlpha);

                    resolve();
                })
                .start();

            const tweenBreath = new Tween(this.continueText.scale, this.tweenGroup)
                .to({ x: 1.03, y: 1.03 }, 1000) // Scale up
                .yoyo(true) // Automatically reverses the tween
                .repeat(Infinity) // Infinite loop
                .onComplete(() => {
                    this.tweenGroup.remove(tweenBreath);
                })
                .start();

        })

    }

    private switchTheBackgroundMusic(toFreeGame: boolean) {

        let targetMusicLoop;
        if (toFreeGame) {
            targetMusicLoop = sound.find('free_background_loop');
        }
        else {
            targetMusicLoop = sound.find('base_music_loop');
        }

        let currentVal: number = currentBackgorundMusicVolume;
        let targetVal: number = 0;

        const tween = new Tween({ x: currentVal }, this.tweenGroup)
            .to({ x: targetVal }, 1000)
            .onUpdate((object) => {
                currentBackgorundMusic.volume = object.x;
                // console.log("this.backGroundMusic", this.backGroundMusic.volume);
            })
            .onComplete(() => {
                this.tweenGroup.remove(tween);
                playFgMusic();

            })
            .start();


        const playFgMusic = () => {
            let currentVal: number = .20;
            let targetVal: number = currentBackgorundMusicVolume;

            // initialize with ambient sound
            setBackgorundMusic(targetMusicLoop);

            const tween = new Tween({ x: currentVal }, this.tweenGroup)
                .to({ x: targetVal }, 1000)
                .onStart(() => {
                    currentBackgorundMusic.loop = true;
                    currentBackgorundMusic.singleInstance = true;
                    currentBackgorundMusic.play();
                    currentBackgorundMusic.muted = !isMusicBtnOnGlobal;
                })
                .onUpdate((object) => {
                    currentBackgorundMusic.volume = object.x;

                    // console.log("this.backGroundMusic", this.backGroundMusic.volume);
                })
                .onComplete(() => {
                    this.tweenGroup.remove(tween);
                })
                .start();
        }
    }



    public async disappearBanner(isBase: boolean): Promise<void> {
        return new Promise<void>((resolve) => {


            if (!isBase) {
                this.switchTheBackgroundMusic(false);
            }

            this.texContainer.alpha = 0;
            this.texContainer.scale.set(0);

            // sound.play('symbol_win', { volume: 0.5 });

            this.backgroundSpine.state.setAnimation(0, "out", false).listener = {
                complete: () => {
                    this.visible = false;
                    this.backgroundSpine.state.clearListeners();
                    this.bgContainer.eventMode = "none";
                    // this.bgContainer.cursor = 'none';
                    resolve();
                }
            };
        });
    }

    public async appearFreeGameOutroBanner(totalWin: number, freeSpins: number) {

        return new Promise<void>((resolve) => {


            this.visible = true;

            this.bannerText3.visible = false;
            this.bannerText4.visible = false;
            this.bannerText5.visible = false;

            this.winText.visible = true;

            this.bannerText1.scale.set(1);
            this.bannerText1.text = translationManager.game('banner_outro_heading_uc');// '8-BIT BONUS';
            this.bannerText1.scale = Math.min(1, 830 / this.bannerText1.width);
            this.bannerText1.y = -275;

            // this.bannerText2.scale = 1;

            this.bannerText2.text = translationManager.game('banner_outro_desc_1', null, { 'winnumber': freeSpins });
            this.bannerText2.y = -100;
            // this.bannerText2.scale = Math.min(1, 850 / this.bannerText2.width);


            this.winText.scale.set(1);
            this.winText.text = totalWin.toFixed(2);
            this.winText.scale = Math.min(1, 850 / this.winText.width);
            this.winText.y = 60;

            this.continueText.y = 300;

            sound.play('Water_Fall', { volume: 0.5 });
            this.backgroundSpine.state.setAnimation(0, "in", false).listener = {
                complete: async () => {
                    sound.play('Free_Game_Banner_Appear', { volume: 0.3 });
                    this.backgroundSpine.state.setAnimation(0, "loop", true);
                    await this.appearText(false);

                    resolve();
                    this.backgroundSpine.state.clearListeners();
                }
            };

        })




    }




    public resize(screenWidth: number, screenHeight: number): void {

        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;

        let scale: number;

        let bgScale;
        const BG_SCALE_FACTOR = Math.max(screenWidth / 1920, screenHeight / 1080);


        if (screenWidth > screenHeight) {
            scale = Math.min(screenWidth / 1920, screenHeight / 1080);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);

            this.texContainer.scale.set(scale, scale);

            // const xPos = (3000 * scale - screenWidth) / 2;
            // const yPos = (3000 * scale - screenHeight) / 2;

            // this.texContainer.x = -xPos;
            // this.texContainer.y = -yPos;

            this.bgContainer.scale.set(bgScale, bgScale)
            const bgXPos = (1920 * bgScale - screenWidth) / 2;
            const bgYPos = (1080 * bgScale - screenHeight) / 2;
            this.bgContainer.position.set(-bgXPos, -bgYPos);

        }
        else {
            scale = Math.min(screenWidth / 1080, screenHeight / 1920);
            bgScale = Math.max(scale, BG_SCALE_FACTOR);

            this.texContainer.scale.set(scale, scale);

            // const xPos = (3000 * scale - screenWidth) / 2;
            // const yPos = (3000 * scale - screenHeight) / 2;

            // this.texContainer.x = -xPos;
            // this.texContainer.y = -yPos;


            this.bgContainer.scale.set(bgScale, bgScale)
            const bgXPos = (1920 * bgScale - screenWidth) / 2;
            const bgYPos = (1080 * bgScale - screenHeight) / 2;
            this.bgContainer.position.set(-bgXPos, -bgYPos);

        }

        this.texContainer.position.set(screenWidth / 2, screenHeight / 2);

    }

    public update(): void {
        // Update the tween group
        this.tweenGroup.update();

    }
}
